import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  avatar: {
    //  backgroundColor: grey[600],
  },
  small: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
}));

const GenderFrequencyIcon = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [frequency, setfrequency] = React.useState("UN");
  const [frequencys, setfrequencys] = useState([
    { name: "A1" },
    { name: "B1" },
    { name: "C1" }
  ]);
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (name) => {
    if (name != "UN") {
      setfrequency(name);
      props.UpdateField("Frequency",name);
    }
    //alert(name);
    setAnchorEl(null);

  };
  useEffect(() => {
   // alert(props.frequency);
    setfrequency(props.frequency);

          
      // put props to square btackets to call ise effect when props change
  }, [props])

  const frequency_avatar = () => {
    return (
      <IconButton
        size="small"
        onClick={handleClick}
        aria-label="Add to favorites"
      >
        <Avatar
          variant="square"
          aria-label="Recipe"
          className={(classes.avatar, classes.small)}
        >
          UR
        </Avatar>
      </IconButton>
    );
  };

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {frequency}
      </Button>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose("UN")}
      >
        {frequencys.map((item) => (
          <MenuItem onClick={() => handleClose(item.name)}>
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
export default GenderFrequencyIcon;
